import { useQuery } from 'react-query';
import { errorHandler } from 'App/utils';
import CompanyService from 'App/services/CompanyService';

function useMedicationSearch(inputValue) {
    return useQuery(
        ['medicationSearch', inputValue],
        () =>
            CompanyService.getLicencedMedications(50, inputValue, true).then((res) => {
                return Object.values(res || {});
            }),
        {
            retry: false, // Avoid duplicate requests on transient failures
            staleTime: 5 * 60 * 1000, // Cache for 5 minutes
            onError: (error) => {
                errorHandler(error);
            },
            refetchInterval: false,
            refetchOnWindowFocus: false,
        }
    );
}

export default useMedicationSearch;
